export const state = {
    mid: sessionStorage.getItem("mid"),
    token: sessionStorage.getItem("token"),
    nickname: sessionStorage.getItem("nickname"),
    expire_ts_sehseh: sessionStorage.getItem("expire_ts_sehseh"),
    avatar: sessionStorage.getItem('avatar')
};
export const actions = {
    ShowLogin({ dispatch, commit, getters, rootGetters }, redirectUrl = "") {
        if (getters.isAuthenticated) {
            return;
        }
        window.vueShowLogin(redirectUrl);
    },
    Logout({ dispatch, commit, getters, rootGetters }, needReload = true) {
        console.log("logout");
        sessionStorage.clear();
        commit('SetMid', null);
        commit('SetToken', null);
        commit('SetNickname', null);
        commit('SetExpireTsSehseh', null);
        commit('SetAvatar', null);
        localStorage.setItem("logout", Date.now());
        if (needReload) window.location.reload();
    }
};
export const mutations = {
    SetMid(state, payload) {
        state.mid = payload;
    },
    SetToken(state, payload) {
        state.token = payload;
    },
    SetNickname(state, payload) {
        state.nickname = payload;
    },
    SetExpireTsSehseh(state, payload) {
        state.expire_ts_sehseh = payload;
    },
    SetAvatar(state, payload) {
        state.avatar = payload;
    }
};
export const getters = {
    isAuthenticated: state => (!!state.mid && !!state.token) || (!!sessionStorage.getItem("mid") && !!sessionStorage.getItem("token")),
    isPremium: state => ((state.expire_ts_sehseh || sessionStorage.getItem('expire_ts_sehseh') || 0) > (Date.now() / 1000 | 0)),
    avatar: state => {
        if (state.avatar) {
            return state.avatar;
        } else if (sessionStorage.getItem('avatar') !== null) {
            return sessionStorage.getItem('avatar');
        }
        return 'https://s3-ap-northeast-1.amazonaws.com/smg-app-resources/user.png';
    }

};

export default {
    state,
    actions,
    mutations,
    getters,
    namespaced: true,
};